module.exports = __webpack_public_path__ + "img/first.de118c2.png";